import { Divider, InputNumber, Table } from "antd";
import { css, styled } from "styled-components";
import { Select } from "antd";
import { MutableRefObject, useEffect, useState } from "react";
import { ISearchPayload, chartType, isEmpty } from "@dataone/lib";
import { ExpandIcon } from "@dataone/icons";

interface DataTableProps {
  // stepRef4: MutableRefObject<null>;
  // setTableExpanded: (tableExpanded: boolean) => void;
  // tableExpanded: boolean;
  response: Partial<ISearchPayload>;
  searchApp: string;
  setResponse: React.Dispatch<React.SetStateAction<Partial<ISearchPayload>>>;
}
function DataTable({
  // stepRef4,
  // tableExpanded,
  // setTableExpanded,
  response,
  searchApp,
  setResponse,
}: DataTableProps) {
  const handleColumnSelected = (value: string[]) => {
    if (value.length <= 1)
      handleChartChange("columnName", isEmpty(value) ? "" : value[0]);
  };

  const handleRowsSelected = (value: string[]) => {
    handleChartChange("rows", value);
  };

  const handleCardColumnLigneChange = (value: number | null) => {
    handleChartChange("cardColumnLigneIndex", value ?? 0);
  };

  const handleChartChange = (
    key: string,
    value: string[] | string | number
  ) => {
    setResponse((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // const handleExpandTable = () => {
  //   setTableExpanded(!tableExpanded);
  // };

  const [fields, setFields] = useState<{ label: string; value: string }[]>();
  const [dataTablecolumns, setDataTablecolumns] =
    useState<{ title: string; dataIndex: string; key: string }[]>();
  useEffect(() => {
    if (response.data) {
      const formattedFields = Object.keys(response.data[0]).map((key) => ({
        label: key,
        value: key,
      }));
      setFields(formattedFields);
      const formattedDataTablecolumns = Object.keys(response.data[0]).map(
        (key) => ({
          title: key,
          dataIndex: key,
          key: key,
        })
      );
      setDataTablecolumns(formattedDataTablecolumns);
    }
  }, []);
  return (
    <StyledTable>
      {/* <div className="expand-table-container">
        <StyledExpandIcon
          onClick={handleExpandTable}
          tableExpanded={tableExpanded}
        >
          <ExpandIcon />
        </StyledExpandIcon>

        <h3>Expand table</h3>
      </div> */}
      <div className="column-selection-container">
        <h3>Column</h3>
        <Select
          className="column-select"
          mode="multiple"
          size="large"
          placeholder="Please select for x values"
          onChange={handleColumnSelected}
          style={{ width: "100%" }}
          options={fields}
          value={isEmpty(response.columnName) ? [] : [response.columnName!]}
        />
      </div>
      <Divider />
      <div className="rows-selection-container">
        {response.chartType === chartType.CARD ? (
          <>
            <h3>Ligne</h3>
            <InputNumber
              defaultValue={response.cardColumnLigneIndex ?? 0}
              controls={false}
              min={0}
              max={999999}
              placeholder="0"
              onChange={handleCardColumnLigneChange}
            />
          </>
        ) : (
          <>
            <h3>Rows</h3>
            <Select
              className="rows-select"
              mode="multiple"
              size="large"
              placeholder="Please select for y values"
              onChange={handleRowsSelected}
              style={{ width: "100%" }}
              options={fields}
              value={response.rows}
            />
          </>
        )}
      </div>
      {/* <TableContainer>
        <Table
          className="table"
          size="small"
          pagination={{ defaultPageSize: 7 }}
          dataSource={response.data}
          columns={dataTablecolumns}
        />
      </TableContainer> */}
      {/* <span ref={stepRef4} /> */}
    </StyledTable>
  );
}

export default DataTable;
const scrollBarStyles = () => css`
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: #d9d9d9;
  }
  &::-webkit-scrollbar-corner {
    background-color: #d9d9d9;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #8b8b8b;
  }

  &::-webkit-scrollbar-button {
    display: block;
    background-color: #d9d9d9;
    border: none;
  }

  &::-webkit-scrollbar-button:single-button:vertical:decrement {
    height: 12px;
    width: 16px;
    background-position: center 6px;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(96, 96, 96)'><polygon points='50,00 0,50 100,50'/></svg>");
  }

  &::-webkit-scrollbar-button:single-button:vertical:increment {
    height: 12px;
    width: 16px;
    background-position: center center;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(96, 96, 96)'><polygon points='0,0 100,0 50,50'/></svg>");
  }

  &::-webkit-scrollbar-button:single-button:horizontal:decrement {
    height: 12px;
    width: 16px;
    background-position: 10px center;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(96, 96, 96)'><polygon points='0,50 50,0 50,100'/></svg>");
  }

  &::-webkit-scrollbar-button:single-button:horizontal:increment {
    height: 12px;
    width: 16px;
    background-position: 6px center;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(96, 96, 96)'><polygon points='50,00 100,50 50,100'/></svg>");
  }
`;
const StyledTable = styled.div`
  // height: 100%;
  border-radius: 9px;
  // background: red;
  padding: 5px 7px;
  width: 100%;
  // margin: 10px 0px 10px 0px;
  .ant-select-multiple.ant-select-lg .ant-select-selection-overflow {
    flex-wrap: nowrap !important;
    overflow: hidden;
    font-size: 12px;
    &::-webkit-scrollbar {
      height: 0px;
    }
    &::-webkit-scrollbar-track {
      background-color: #eff1fd;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #040726;
      border-radius: 20px;
    }
  }
  .table {
    overflow-x: auto;
    max-height: 247px;
    min-height: 247px;
    background: #fff;
    ${scrollBarStyles}
  }
  .ant-table-thead .ant-table-cell {
    background-color: #eff1fd;
  }

  // width: 100%;

  .expand-table-container {
    display: flex;
    align-items: center;
    height: 40px;
    h3 {
      color: #040726;
      font-size: 15px;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.18px;
      margin-left: 20px;
      margin-block-start: 1em;
    }
    img {
      cursor: pointer;
    }
  }
  .column-selection-container {
    display: flex;
    align-items: center;
    background: #fff;
    padding-left: 10px;
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    margin-bottom: 6px;
    min-width: 180px;
    h3 {
      color: #040726;
      font-size: 15px;
      font-weight: 700;
      line-height: normal;
      letter-spacing: -0.18px;
      margin: 13px 0px;
    }
    .column-select {
      width: calc(100% - 65px) !important;
      margin-left: auto;
    }
  }
  .rows-selection-container {
    display: flex;
    align-items: center;
    background: #fff;
    padding-left: 10px;
    border-bottom-left-radius: 9px;
    border-bottom-right-radius: 9px;
    min-width: 180px;
    h3 {
      color: #040726;
      font-size: 15px;
      font-weight: 700;
      line-height: normal;
      letter-spacing: -0.18px;
      margin: 13px 0px;
      width: 65px;
    }
    .rows-select {
      margin-left: auto;
      // width: 88% !important;
      width: 79% !important;
    }
  }
  .ant-input-number {
    margin-left: auto;
    width: 88% !important;
    outline: none;
    border: none;
    box-shadow: none;
  }
  .ant-select .ant-select-selector {
    border: none;
  }
  .ant-select-focused.ant-select .ant-select-selector {
    box-shadow: none !important;
  }
  .ant-select-multiple.ant-select-lg .ant-select-selection-item {
    border-radius: 6px;
    border-bottom: 1.5px solid #4974f6;
    background: #eff1fd;
  }
  .ant-divider-horizontal {
    margin: 0px;
    display: none;
  }
`;
const TableContainer = styled.div`
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid #4974f6;
  margin: 10px 0px;
  .ant-table-wrapper .ant-table.ant-table-small {
    font-size: 12px;
  }
`;

const StyledExpandIcon = styled.div<{ tableExpanded: boolean }>`
  cursor: pointer;
  display: flex;
  font-size: 20px;
  align-items: center;
  transform: ${(props) =>
    props.tableExpanded ? "rotate(0deg)" : "rotate(180deg)"};
  width: 20px;
`;
